import { createAction, props } from '@ngrx/store';
import { FarmWeatherLocation } from '../_models/farmWeatherLocation';

// Action types
export const loadFarmWeatherLocations = createAction(
  '[FarmWeatherLocation] Load FarmWeatherLocations'
);
export const loadFarmWeatherLocationsSuccess = createAction(
  '[FarmWeatherLocation] Load FarmWeatherLocations Success',
  props<{ locations: FarmWeatherLocation[] }>()
);
export const loadFarmWeatherLocationsFailure = createAction(
  '[FarmWeatherLocation] Load FarmWeatherLocations Failure',
  props<{ error: any }>()
);

export const loadFarmWeatherLocation = createAction(
  '[FarmWeatherLocation] Load FarmWeatherLocation',
  props<{ id: number }>()
);
export const loadFarmWeatherLocationSuccess = createAction(
  '[FarmWeatherLocation] Load FarmWeatherLocation Success',
  props<{ location: FarmWeatherLocation }>()
);
export const loadFarmWeatherLocationFailure = createAction(
  '[FarmWeatherLocation] Load FarmWeatherLocation Failure',
  props<{ error: any }>()
);

export const addFarmWeatherLocation = createAction(
  '[FarmWeatherLocation] Add FarmWeatherLocation',
  props<{ location: FarmWeatherLocation }>()
);
export const addFarmWeatherLocationSuccess = createAction(
  '[FarmWeatherLocation] Add FarmWeatherLocation Success',
  props<{ location: FarmWeatherLocation }>()
);
export const addFarmWeatherLocationFailure = createAction(
  '[FarmWeatherLocation] Add FarmWeatherLocation Failure',
  props<{ error: any }>()
);

export const updateFarmWeatherLocation = createAction(
  '[FarmWeatherLocation] Update FarmWeatherLocation',
  props<{ location: FarmWeatherLocation }>()
);
export const updateFarmWeatherLocationSuccess = createAction(
  '[FarmWeatherLocation] Update FarmWeatherLocation Success',
  props<{ location: FarmWeatherLocation }>()
);
export const updateFarmWeatherLocationFailure = createAction(
  '[FarmWeatherLocation] Update FarmWeatherLocation Failure',
  props<{ error: any }>()
);

export const deleteFarmWeatherLocation = createAction(
  '[FarmWeatherLocation] Delete FarmWeatherLocation',
  props<{ location: FarmWeatherLocation }>()
);
export const deleteFarmWeatherLocationSuccess = createAction(
  '[FarmWeatherLocation] Delete FarmWeatherLocation Success',
  props<{ location: FarmWeatherLocation }>()
);
export const deleteFarmWeatherLocationFailure = createAction(
  '[FarmWeatherLocation] Delete FarmWeatherLocation Failure',
  props<{ error: any }>()
);
